// @flow

import { Map, fromJS } from 'immutable';

export const GET_VIDEO_DETAILS = 'App/Preview/GET_VIDEO_DETAILS';
export const GET_VIDEO_DETAILS_SUCCESS = 'App/Preview/GET_VIDEO_DETAILS_SUCCESS';
export const GET_VIDEO_DETAILS_FAIL = 'App/Preview/GET_VIDEO_DETAILS_FAIL';
export const CLEAR_VIDEO_DETAILS = 'App/Preview/CLEAR_VIDEO_DETAILS';

export const BOOKMARK_VIDEO = 'App/Preview/BOOKMARK_VIDEO';
export const BOOKMARK_VIDEO_SUCCESS = 'App/Preview/BOOKMARK_VIDEO_SUCCESS';
export const BOOKMARK_VIDEO_FAIL = 'App/Preview/BOOKMARK_VIDEO_FAIL';

export const RATE_VIDEO = 'App/Preview/RATE_VIDEO';
export const RATE_VIDEO_SUCCESS = 'App/Preview/RATE_VIDEO_SUCCESS';
export const RATE_VIDEO_FAIL = 'App/Preview/RATE_VIDEO_FAIL';

const initialState = Map({
  getVideoDetailsLoading: false,
  videoDetails: Map({}),
  getVideoDetailsFail: null,
  bookmarkVideoLoading: false,
  bookmarkVideoSuccess: Map({}),
  bookmarkVideoFail: null,
  rateVideoLoading: false,
  rateVideoSuccess: Map({}),
  rateVideoFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_VIDEO_DETAILS:
      return state.merge({
        getVideoDetailsLoading: true,
        getVideoDetailsFail: null,
      });
    case GET_VIDEO_DETAILS_SUCCESS:
      return state.merge({
        getVideoDetailsLoading: false,
        videoDetails: fromJS(action.data),
      });
    case GET_VIDEO_DETAILS_FAIL:
      return state.merge({
        getVideoDetailsLoading: false,
        getVideoDetailsFail: fromJS(action.data),
      });
    case CLEAR_VIDEO_DETAILS:
      return state.merge({
        getVideoDetailsLoading: false,
        videoDetails: Map({}),
        getVideoDetailsFail: null,
      });
    case BOOKMARK_VIDEO:
      return state.merge({
        bookmarkVideoLoading: true,
      });
    case BOOKMARK_VIDEO_SUCCESS:
      return state.merge({
        bookmarkVideoLoading: false,
        bookmarkVideoSuccess: fromJS(action.data),
      });
    case BOOKMARK_VIDEO_FAIL:
      return state.merge({
        bookmarkVideoLoading: false,
        bookmarkVideoFail: fromJS(action.data),
      });
    case RATE_VIDEO:
      return state.merge({
        rateVideoLoading: true,
      });
    case RATE_VIDEO_SUCCESS:
      return state.merge({
        rateVideoLoading: false,
        rateVideoSuccess: fromJS(action.data),
      });
    case RATE_VIDEO_FAIL:
      return state.merge({
        rateVideoLoading: false,
        rateVideoFail: fromJS(action.data),
      });
    default:
      return state;
  }
};

export const getVideoDetails = (data : { id : string, season : ?number, }) =>
  (dispatch : any) => dispatch({ type: GET_VIDEO_DETAILS, data });

export const bookmarkVideo = (data : { id : string, link : string, }) =>
  (dispatch : any) => dispatch({ type: BOOKMARK_VIDEO, data });

export const rateVideo = (data : { id : string, rate : number, }) =>
  (dispatch : any) => dispatch({ type: RATE_VIDEO, data });

export const clearVideoDetails = () => (dispatch : any) => dispatch({ type: CLEAR_VIDEO_DETAILS });
